export default "__VITE_ASSET__CEK3tWgD__"